var Location = {
	/**
	 * @description Get the current window.location, usefull for testing mocking
	 * @function
	 * @name Location#getLocation
	 */
	getLocation: function() {
		return window.location;
    },

	/**
	 * @description force an URL to be the same origin as the current one, throw an error if it is of strange origin
	 * @function
	 * @name Location#forceSameOrigin
	 * @param {String} pURL the url to be force
	 * @returns {String} url with same origin 
	 */
	forceSameOrigin: function(pURL) {
		if (typeof pURL !== "string" || pURL.length <= 0) {
			throw new Error("url parameter should be a not empty string");
		}
		if (pURL[0] === "/") {
			// force same origin, is pointing to root
			return window.location.origin + pURL;
		} else if (this.hasSameOrigin(pURL)) {
			// contains already same origin, leave it
			return pURL;
		} else {
			// could do nothing, probably wrong origin!!
			throw new Error("redirection to other origin blocked");
		}
	},
	
	hasSameOrigin: function(pInputUrl) {
		if (typeof URL === "function") {
			try {
				var url = new URL(pInputUrl, window.location.href);
				return url.origin === window.location.origin;
			} catch(e) {
				return false;
			}
		} else {
			// fallback old browsers
			return hasDifferentOrigin(pInputUrl) === false;
		}
	}
};

// AI Codex
function normalizedPort(pProtocol, pPort) {
	if (pPort) {
		return pPort;
	}
	if (pProtocol === "http:") {
		return "80";
	}
	if (pProtocol === "https:") {
		return "443";
	}
  return "";
}

function hasDifferentOrigin(inputUrl) {
	var link = document.createElement("a");
	link.href = inputUrl;

	var targetProtocol = link.protocol;
	var targetHost = link.hostname;
	var targetPort = normalizedPort(targetProtocol, link.port);

	var currentProtocol = window.location.protocol;
	var currentHost = window.location.hostname;
	var currentPort = normalizedPort(currentProtocol, window.location.port);

	return (
		targetProtocol !== currentProtocol ||
		targetHost !== currentHost ||
		targetPort !== currentPort
	);
}
// IA

module.exports = Location;